/** Must match server `server/src/constants/activityHostLimits.js`. */
export const UNVERIFIED_HOST_ACTIVITY_LIMIT = 3;
